/**
 * Settings and special Ajax handling for Pace.js
 */

import $ from 'jquery';
import Pace from 'pace-js';

// ignore Ajax calls with specific url (regex allowed) and/or GET/POST parameters
const ignoreRequests = [
    {
        url: '/@@chatajax',
    },
    {
        url: '/@@fc-',
        parameters: {
            transitions: 'true',
            render: 'yes',
        },
    },
];

// set some Pace options
Pace.options.ajax = false; // we do the ajax handling on our own
Pace.options.restartOnPushState = false;
Pace.options.restartOnRequestAfter = false;
Pace.options.startOnPageLoad = false;

const noPaceClass = 'no-pace';
let ajaxCount = 0;

// Add a no-pace class to the body and let Pace watch for it
$('body').addClass(noPaceClass);
Pace.options.elements.selectors.push(`body.${noPaceClass}`);

/**
 * Check a url against a pattern
 * @param {String} url
 * @param {String|RegExp} pattern
 * @returns {Boolean}
 */
const shouldIgnoreURL = (url, pattern) => {
    if (typeof pattern === 'string') {
        if (url.indexOf(pattern) !== -1) {
            return true;
        }
    } else if (pattern.test(url)) {
        return true;
    }
    return false;
};

/**
 * Check a request (url and payload) against our ignoreRequests configuration
 * @param {String} url
 * @param {String} parameters - urlencoded parameters
 * @returns {Boolean} - whether this request should be ignored
 */
const shouldIgnore = (url, parameters) => ignoreRequests.some((ignore) => {
    if ('url' in ignore && !shouldIgnoreURL(url, ignore.url)) {
        // url doesn't match
        return false;
    }

    if (!('data' in ignore)) {
        // url seems to match and there are no parameters to check against
        return true;
    }

    // "URLSearchParams" is not supported in Opera Mini, so ignore params here
    if (!('URLSearchParams' in window)) {
        return false;
    }

    // check against the parameters
    // eslint-disable-next-line compat/compat
    const params = new URLSearchParams(parameters);
    return Object.entries(ignore.parameters)
        .every(([key, value]) => params.get(key) === value);
});

// Do the Ajax magic here. We let Pace watch for a class on body
// and remove this class while Ajax calls are done.
$(document).ajaxSend((evt, request, settings) => {
    if (shouldIgnore(settings.url, settings.data)) {
        return;
    }

    if (ajaxCount === 0) {
        $('body').removeClass(noPaceClass);
        Pace.restart();
    }
    ajaxCount += 1;
});

$(document).ajaxComplete((evt, request, settings) => {
    if (shouldIgnore(settings.url, settings.data)) {
        return;
    }

    ajaxCount -= 1;
    if (ajaxCount === 0) {
        // Add a fake element to trick Pace
        $('body').addClass(noPaceClass);
    }
});
